import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function DivisionPage({ enterprise, divisionId, divisions }) {
  const { t } = useTranslation();
  const division = divisions.find(division => division.division_id === divisionId);

  if (!division || !enterprise) {
    return <div>{t('loading')}</div>;
  }

  return (
    <div className="container">
      <h1>{enterprise.name} - {division.name}</h1>
      {/* Дополнительная информация о подразделении */}
      <p>{t('division_details')}: {division.details}</p>
    </div>
  );
}

export default DivisionPage;
